import EmptyPayments from './EmptyPayments';

export default EmptyPayments;
